import { BrowserRouter, Routes, Route } from "react-router-dom";

import React from "react";
import HomePage from "../pages/HomePage";
import CreateAccount from "../pages/CreateAccount";
import { ToastContainer } from "react-toastify";
import DashboardPage from "../pages/private/DashboardPage";

import NavbarComponent from "../components/NavbarComponent";
import NotFound from "../pages/NotFound";
import AccountCreatedConfirmation from "../pages/AccountCreatedConfirmation";
import ActivateAccount from "../pages/ActivateAccount";
import ConfirmPosting from "../pages/ConfirmPosting";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import ForgotPassword from "../pages/ForgotPassword";
import ResetPassword from "../pages/ResetPassword";

import LoadingPage from "../components/LoadingPage";
import { useAuth } from "./useAuth";

function MainRoutes() {
  const { loading, user } = useAuth();

  const privateRoutes = [
    { path: "/", component: <DashboardPage /> },
    { path: "/confirmposting/:id", component: <ConfirmPosting /> },
    { path: "/privacy-policy", component: <PrivacyPolicy /> },
    { path: "/terms-of-service", component: <TermsOfService /> },
    { path: "*", component: <NotFound /> },
  ];
  const publicRoutes = [
    { path: "/", component: <HomePage /> },
    { path: "/createaccount", component: <CreateAccount /> },
    { path: "/accountcreated", component: <AccountCreatedConfirmation /> },
    { path: "/activateaccount/:id", component: <ActivateAccount /> },
    { path: "/forgotpassword", component: <ForgotPassword /> },
    { path: "/privacy-policy", component: <PrivacyPolicy /> },
    { path: "/terms-of-service", component: <TermsOfService /> },
    { path: "/resetpassword/:id", component: <ResetPassword /> },
    { path: "*", component: <HomePage /> },
  ];

  if (loading) {
    return <LoadingPage />;
  }
  return (
    <BrowserRouter>
      {user && <NavbarComponent />}
      <ToastContainer />
      {user ? (
        <Routes>
          {privateRoutes.map((c, i) => (
            <Route key={i} path={c.path} element={c.component} />
          ))}
        </Routes>
      ) : (
        <Routes>
          {publicRoutes.map((c, i) => (
            <Route key={i} path={c.path} element={c.component} />
          ))}
        </Routes>
      )}
    </BrowserRouter>
  );
}

export default MainRoutes;
